import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import AppHandoff from "../../ui/AppHandoff";
import useDocumentTitle from "../../../hook/useDocumentTitle";

// Reached via the universal link https://launchpad.saltplatform.com/app/login/{code}.

export default function Login() {
  const { code } = useParams<{ code: string }>();
  const { t } = useTranslation("login");
  useDocumentTitle(t("documentTitle"));

  return <AppHandoff heading={t("heading")} instructions={t("instructions")}>
    {code && <div className="flex flex-col items-center gap-2">
      <span className="text-sm text-gray-500 uppercase tracking-wide">
        {t("codeLabel")}
      </span>
      <code className="px-4 py-2 bg-gray-100 rounded-lg text-lg font-mono tracking-widest break-all max-w-full">
        {code}
      </code>
    </div>}
  </AppHandoff>
}
